import React from 'react' // eslint-disable-line no-unused-vars
import '../../css/ui-elements/alerts.css'

const Alert = ({ className, children }) =>
  <div className={className} role='alert'>
    {children}
  </div>

export default Alert



// WEBPACK FOOTER //
// ./src/ui-elements/alerts/Alert.js